import type { ProductsQueryRequestModel } from '@/shared/generated'

import React, { useMemo } from 'react'
import { Link } from '@tanstack/react-router'
import { prop } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import {
	useAssortmentListQuery,
	useUnassignedProductsCountQuery,
} from '@/entities/assortment'
import { getAssortmentShare } from '@/entities/pricing-campaign'

import { PercentageValueText } from '@/shared/components/common/PercentageValueText'
import { Operators } from '@/shared/components/query-builder'
import { Badge } from '@/shared/components/ui/badge'
import { Spinner } from '@/shared/components/ui/spinner'
import { getFiltersQueryString } from '@/shared/tools/location'

export default function GlobalAssortmentUnassignedItems() {
	const { t } = useTranslation()

	const totalQuery = useAssortmentListQuery<number>(defaultBody, queryOptions)
	const unassignedQuery = useUnassignedProductsCountQuery()
	const isLoading = unassignedQuery.isLoading || totalQuery.isLoading
	const count = unassignedQuery.data || 0
	const share = getAssortmentShare(totalQuery.data ?? 0, count)
	const variant =
		share == 100 ? 'destructive' : share > 5 ? 'warning' : 'success'
	const link = useMemo(
		() =>
			`../products${getFiltersQueryString([
				{
					name: 'pricing_campaign_id',
					operation: Operators.IS_EMPTY as const,
					value: '1',
				},
			])}`,
		[]
	)

	return (
		<Badge
			variant={variant}
			className='gap-1 no-underline fade-in'
			interactive
			asChild
		>
			<Link to={link}>
				{isLoading ? (
					<Spinner data-icon='inline-start' />
				) : (
					<PercentageValueText value={count} percentage={share} />
				)}
				<span>{t('general_new_items')}</span>
			</Link>
		</Badge>
	)
}

const defaultBody: ProductsQueryRequestModel = {
	limit: 1,
	offset: 0,
	order_by: [],
	filters: [],
}
const queryOptions = {
	select: prop('total_count'),
}
